import { createTheme } from '@mui/material';
import { tokens } from './tokens';

declare module '@mui/material/styles' {
  interface Palette {
    chart: {
      income: string;
      expense: string;
      trend: string;
    }
  }
  interface PaletteOptions {
    chart: {
      income: string;
      expense: string;
      trend: string;
    }
  }
  interface TypeBackground {
    light: string;
    dark: string;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: tokens.colors.primary.main,
      light: tokens.colors.primary.light,
      dark: tokens.colors.primary.dark,
    },
    secondary: {
      main: tokens.colors.secondary.main,
      light: tokens.colors.secondary.light,
      dark: tokens.colors.secondary.dark,
    },
    success: {
      main: tokens.colors.success.main,
      light: tokens.colors.success.light,
      dark: tokens.colors.success.dark,
    },
    error: {
      main: tokens.colors.error.main,
      light: tokens.colors.error.light,
      dark: tokens.colors.error.dark,
    },
    warning: {
      main: tokens.colors.warning.main,
      light: tokens.colors.warning.light,
      dark: tokens.colors.warning.dark,
    },
    background: {
      default: tokens.colors.background.light,
      light: tokens.colors.background.light,
      dark: tokens.colors.background.dark,
    },
    chart: {
      income: tokens.colors.chart.income,
      expense: tokens.colors.chart.expense,
      trend: tokens.colors.chart.trend,
    },
  },
  shape: {
    borderRadius: parseInt(tokens.borderRadius.md),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: tokens.borderRadius.md,
          textTransform: 'none',
        },
      },
    },
  },
});
